var map = {
	"./logo_chatdesk.svg": 218,
	"./logo_customerio.svg": 525,
	"./logo_facebook.svg": 277,
	"./logo_freshdesk.svg": 347,
	"./logo_frontapp.svg": 348,
	"./logo_gladly.svg": 349,
	"./logo_gorgias.svg": 350,
	"./logo_helpscout.svg": 351,
	"./logo_instagram.svg": 278,
	"./logo_kustomer.svg": 352,
	"./logo_salesforce.svg": 526,
	"./logo_shopify.svg": 279,
	"./logo_tiktok.svg": 280,
	"./logo_tiktokads.svg": 527,
	"./logo_trustpilot.svg": 528,
	"./logo_twitter.svg": 353,
	"./logo_whistle.svg": 354,
	"./logo_youtube.svg": 529,
	"./logo_zendesk.svg": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2124;